import React, { useEffect } from "react";
import styles from "./CardItemSmallList.module.css";

import { CardItemSmall } from "../index";
import Grid from "@material-ui/core/Grid";
import { useDispatch, useSelector } from "react-redux";
import { fetchListProductNewRequest } from "redux/ActionCreators/ProductActionCreators";
import toArrayImageFromImageRegex from "shared/func/toArrayImageFromImageRegex";

const CardItemSmallList = ({ size, itemOnRow }) => {
  const products = useSelector((state) => state.products.listNews);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchListProductNewRequest(size));
  }, []);

  if (!products) return <div>Loading...</div>;
  return (
    <div className={styles.container}>
      <Grid container spacing={1}>
        {products.map((item, index) => {
          return (
            <Grid item xs={6} key={index} sm={12 / itemOnRow}>
              <CardItemSmall
                id={item.id}
                imgPath={toArrayImageFromImageRegex(item.imageRegex)[0]}
                title={item.name}
                price={item.price}
                priceDiscount={item.priceDiscount}
                discount={`${
                  100 - parseInt((item.priceDiscount / item.price) * 100)
                }%`}
              />
            </Grid>
          );
        })}
      </Grid>
    </div>
  );
};

export default CardItemSmallList;
